import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';

const faqItems = [
  {
    question: '这是一款什么产品？',
    answer: `Aiabc英语自主学习系统，将先进的<b>“人工智能辅助学习技术”</b>融入英语教育实践，凭借Ai科学算法，为学生定制契合的专属学习方案，通过学习方案契合自身学习能力，从而实现全方位的学习效率提升。<br />
该系统满足学生在应试教育中获取高分的需求，也服务于学生获得真正英语思维与口语能力的提高，投入市场12年来已有30万学生从中受益并给予好评。凭借透彻的学科理解、丰富系统的内容研发、先进科学的推荐算法、卓越显著的学习效果，赢得了国内众多一线名师以及一流教育培训机构的认可与推荐。<br />
Aiabc凭借领先的卓越的系统平台，为广大学子提供全方位的<b>“英语学习一站式高效提分”</b>服务，满足小学、初中、高中等各阶段的英语提高需求。由于学生及家长推崇，现已成为国内颇具影响力的英语学习品牌。`
  },
  {
    question: '英语改革2024改了什么？',
    answer: `<b>1. 高考英语科目的改革：</b><br />2024年的高考英语科目将依据《普通高中英语课程标准（2017年版2020年修订）》进行命题，试卷结构将进行调整，以适应新课改和新高考的要求。改革的内容包括减少语言知识运用类试题的题量和分值，增加语言运用能力试题的分值，题型更加多样化，以及减少或不再使用传统题型。<br />
<b>2.考试内容与形式改革：</b><br />英语科命题坚持落实立德树人根本任务，强化对阅读理解、书面表达等关键能力的考查，启用新题型，如语法填空和读后续写，以正向引导基础教育阶段的英语教育教学。<br />
<b>3.关键能力考查：</b><br />试题突出对阅读和写作能力的考查，强化了批判性思维能力和创造性思维能力的考查，以引导学生全面发展。`
  },
  {
    question: '行业发展前景分析',
    answer: `<b>1.个性化学习需求增加</b><br />家长对于个性化、定制化的学习需求不断增加，Ai教育能够满足不同消费者的学习需求。<br />
<b>2.高质量教育资源需求</b><br />家长对高质量的教育资源有着强烈的需求，Ai教育通过技术手段提供优质的教育资源和服务。<br />
<b>3.学习效率提升需求</b><br />家长希望通过Ai教育提高学习效率， 实现更高效的学习成果。
`
  },
  {
    question: '系统能解决什么问题？',
    answer: `<b>1.解决学生的困扰</b><br />学生低分的困扰四大原因：单词记不住；阅读看不懂；一刀切教学方式；不会学和学不会。<br />
<b>2.解决家长的焦虑</b><br />家长对长期不提分的焦虑：精力有限，无法辅导孩子；生气式督促导致提分困难；孩子排斥引起亲子矛盾。<br />
<b>3.解决都是的无奈</b><br />英语老师教课不提分的无奈：学生分层引起的教学困难；学生课后不背导致单词不会、阅读不懂；老师用心但学生成绩平平。`
  },
    {
        question: '产品体系定位？',
        answer: `<b>适用对象：</b><br />小学（四年级以上）、初中、高中学生。<br />
<b>产品定位：</b><br />英语智能高效提分一站式解决方案。`
    },
    {
      question: '产品的亮点？',
      answer: `1.用人文与科技赋能，引领时代潮流；<br />
2.冲分有保障，产品设计科学合理，专属规划师全程舒普深；<br />
3.一对一定制中/高考专属冲刺计划；<br />
4.哈佛博士独家课程；<br />
5.全方位设计，让每个学生找到适合自己的英语学习解决方案。`
    },
  {
    question: '数据安全性如何保障？',
    answer: '数据安全是我们的首要任务。我们使用先进的加密技术和安全协议来保护您的数据。我们的系统定期进行安全审计，以确保高级别的数据保护。'
  }
];

const FAQ = () => {
  const [activeIndex, setActiveIndex] = useState(null);

  const toggleItem = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  return (
    <section id="faq" className="py-20 bg-gray-50 dark:bg-gray-800 pt-40">
      <div className="container">
        <motion.div
          className="section-title"
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          viewport={{ once: true }}
        >
          <h2 className="text-3xl md:text-4xl font-bold text-primary dark:text-white mb-4">常见问题</h2>
          <p className="text-base md:text-lg text-gray-700 dark:text-gray-300 max-w-2xl mx-auto">我们产品和服务的一些常见问题</p>
        </motion.div>

        <div className="mt-12 max-w-3xl mx-auto">
          {faqItems.map((item, index) => (
            <motion.div
              key={index}
              className="mb-4"
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5, delay: index * 0.1 }}
              viewport={{ once: true }}
            >
              <button
                className={`w-full p-4 text-left text-lg font-medium rounded-lg flex justify-between items-center ${
                  activeIndex === index
                    ? 'bg-secondary/10 dark:bg-secondary/20 text-secondary'
                    : 'bg-white dark:bg-gray-700 text-primary dark:text-white hover:bg-gray-50 dark:hover:bg-gray-600'
                }`}
                onClick={() => toggleItem(index)}
              >
                {item.question}
                <span className="flex-shrink-0 ml-2">
                  {activeIndex === index ? (
                    <i className="fas fa-minus text-secondary"></i>
                  ) : (
                    <i className="fas fa-plus text-primary dark:text-gray-400"></i>
                  )}
                </span>
              </button>

              <AnimatePresence>
                {activeIndex === index && (
                  <motion.div
                    initial={{ height: 0, opacity: 0 }}
                    animate={{ height: 'auto', opacity: 1 }}
                    exit={{ height: 0, opacity: 0 }}
                    transition={{ duration: 0.3 }}
                    className="overflow-hidden"
                  >
                    <div className="p-4 bg-white dark:bg-gray-700 rounded-b-lg border-t-0 border border-gray-100 dark:border-gray-600 text-gray-600 dark:text-gray-300 leading-8" dangerouslySetInnerHTML={{__html: item.answer}}>
                      {/*{ item.answer }*/}
                    </div>
                  </motion.div>
                )}
              </AnimatePresence>
            </motion.div>
          ))}
        </div>

        {/*<motion.div*/}
        {/*  className="mt-16 text-center"*/}
        {/*  initial={{ opacity: 0 }}*/}
        {/*  whileInView={{ opacity: 1 }}*/}
        {/*  transition={{ duration: 0.6, delay: 0.4 }}*/}
        {/*  viewport={{ once: true }}*/}
        {/*>*/}
        {/*  <p className="text-gray-700 mb-6">还有其他问题？请直接联系我们</p>*/}
        {/*  <button className="btn bg-primary hover:bg-secondary">联系我们</button>*/}
        {/*</motion.div>*/}
      </div>
    </section>
  );
};

export default FAQ;
